// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { UserStateAWSError } from "types";
import { IAction } from "actions";
import { IState } from "states/states";
import { isSet } from "shared/utils/utils";

interface ILoginErrorStatusProps {
  userStateAWSFeedback: UserStateAWSError | undefined;
  userStateError: string | undefined;
}

const mapStateToProps = (state: IState) => {
  const props: ILoginErrorStatusProps = {
    userStateAWSFeedback: state.gui.login.userStateAWSFeedback,
    userStateError: state.gui.login.userStateErrorInfo,
  };
  return props;
};

interface ILoginErrorStatusDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ILoginErrorStatusDispatch = {};
  return dispatchProps;
};

class LoginErrorStatusComponent extends React.Component<
  ILoginErrorStatusProps & ILoginErrorStatusDispatch
> {
  public render() {
    let alertbox = <></>;

    switch (this.props.userStateAWSFeedback) {
      case UserStateAWSError.CONFIRMATION_PENDING:
        alertbox = (
          <div className="alert alert-warning mt-2">
            <FormattedMessage id="Pending sign-up confirmation." />
          </div>
        );
        break;
      case UserStateAWSError.SIGNUP_USER_EXISTS:
        alertbox = (
          <div className="alert alert-warning mt-2">
            <FormattedMessage id="User already exists - try to login." />
          </div>
        );
        break;
      case UserStateAWSError.SIGNUP_UNSUPPORTED_COMPANY:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="This email address is not allowed to sign-up." />{" "}
            <FormattedMessage id="Please contact your administrator." />
          </div>
        );
        break;
      case UserStateAWSError.CODE_EXPIRED:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Code has expired - request a new one." />
          </div>
        );
        break;
      case UserStateAWSError.CODE_MISMATCH:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Code not valid - request a new one." />
          </div>
        );
        break;
      case UserStateAWSError.PASSWORD_INVALID:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Password does not meet minimum requirements on length and complexity." />
          </div>
        );
        break;
      case UserStateAWSError.ALREADY_CONFIRMED:
        alertbox = (
          <div className="alert alert-warning mt-2">
            <FormattedMessage id="You are already confirmed - try to login." />
          </div>
        );
        break;
      case UserStateAWSError.CONFIRMATION_FAILED:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Confirmation failed - please try again." />
          </div>
        );
        break;
      case UserStateAWSError.USERNAME_MISSING:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Email missing - please enter your email." />
          </div>
        );
        break;
      case UserStateAWSError.PASSWORD_MISSING:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Password missing - please enter your password." />
          </div>
        );
        break;
      case UserStateAWSError.CODE_MISSING:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Confirmation code missing - please enter the code." />
          </div>
        );
        break;
      default:
      case UserStateAWSError.UNKNOWN:
        if (isSet(this.props.userStateError) && this.props.userStateError !== "") {
          alertbox = (
            <div className="alert alert-danger mt-2">
              <FormattedMessage id="Unknown error: " />
              {this.props.userStateError}
            </div>
          );
        }
        break;
      case UserStateAWSError.LOGIN_FAILED:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Login failed." />
          </div>
        );
        break;
      case UserStateAWSError.PASSWORD_CHANGE_FAIL:
        alertbox = (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Changing password failed." />
            <br></br>
            {isSet(this.props.userStateError) && (
              <FormattedMessage id={this.props.userStateError} />
            )}
          </div>
        );
        break;
    }
    return alertbox;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginErrorStatusComponent);
